import { render } from "./ProductDeliveryPayment.vue?vue&type=template&id=c0243c70"
import script from "./ProductDeliveryPayment.vue?vue&type=script&lang=js"
export * from "./ProductDeliveryPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__